import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import './i18n';
import { initAnalytics, initSentry, initPostHog } from './lib/analytics';
import { registerServiceWorker } from './lib/registerSW';

// Boot analytics + error monitoring BEFORE the app mounts
initSentry();
initAnalytics();
initPostHog();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
